import type { FaireProductEntity } from "../../entity_types/product";

export const p_qt247vdamg: FaireProductEntity = {
  token: "p_qt247vdamg",
  type: "product",
  name: "Cat's Meow Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/11a31f1f57456443d24f860f82a2e629a7822bcd7b7c296794320b97bd66be78.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/acdc873b9a715bd8ad723e593f5b4aa8bcff78ab92d0c69184598f14aa651095.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:16.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
